//RJT - Added entire file to control mouse over on menu behavior verses click on parant menu item
document.addEventListener('DOMContentLoaded', () => {
  // Desktop only (mouse / >= 990px like Dawn)
  const desktop = window.matchMedia('(pointer:fine) and (min-width: 990px)');
  if (!desktop.matches) return;

  document.querySelectorAll('summary[data-parent-href]').forEach((summary) => {
    const details = summary.closest('details');
    const url = summary.dataset.parentHref;
    if (!details || !url) return;

    let closeTimer;

    // Hover to open; leave to close (small delay to prevent flicker)
    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => details.removeAttribute('open'), 150);
    });

    // Click navigates to the parent URL (don’t toggle the menu)
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.assign(url);
    });

    // Keep keyboard accessible: Enter toggles, Shift+Enter navigates
    summary.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        window.location.assign(url);
      }
    });
  });
});
